module.exports = __webpack_public_path__ + "img/Derek-Veitch.cc2515c7.jpg";